import { useEffect } from 'react';

export function Analytics() {
  useEffect(() => {
    const TRACKING_ID = '87366624f3f7b647';
    const API_URL = 'https://app.grozda.com/api/site-monitoring/track';
    const startTime = Date.now();
    
    const generateId = () => 
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
      });
    
    let visitorId = localStorage.getItem('_ps_vid');
    if (!visitorId) {
      visitorId = generateId();
      localStorage.setItem('_ps_vid', visitorId);
    }
    
    let sessionId = sessionStorage.getItem('_ps_sid');
    if (!sessionId) {
      sessionId = generateId();
      sessionStorage.setItem('_ps_sid', sessionId);
    }
    
    const sendPageView = () => {
      const data = {
        tracking_id: TRACKING_ID,
        page_url: window.location.href,
        page_title: document.title,
        referrer: document.referrer || null,
        visitor_id: visitorId,
        session_id: sessionId,
        user_agent: navigator.userAgent,
        screen_width: window.screen.width,
        screen_height: window.screen.height,
        load_time_ms: Date.now() - startTime,
        language: navigator.language || null
      };
      
      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        keepalive: true
      }).catch(() => {});
    };
    
    if (document.readyState === 'complete') {
      sendPageView();
    } else {
      window.addEventListener('load', sendPageView);
      return () => window.removeEventListener('load', sendPageView);
    }
  }, []);
  
  return null;
}

export default Analytics;
